import React from 'react'
import PropTypes from 'prop-types'

import { Wrapper, TextBlock, TextWrapper, Paragraph } from './OurMission.styles'

const LogoGraphic = ({ head, para, bgColor }) => {
  return (
    <Wrapper>
      <TextBlock bgColor={bgColor}>
        <TextWrapper>
          <h1>{head}</h1>
          <Paragraph>{para}</Paragraph>
        </TextWrapper>
      </TextBlock>
    </Wrapper>
  )
}

LogoGraphic.defaultProps = {
  head: `Our Mission`,
  para: null,
  bgColor: 'grey',
}

LogoGraphic.propTypes = {
  head: PropTypes.string,
  para: PropTypes.element,
  bgColor: PropTypes.string,
}

export default LogoGraphic
